/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IPisos from 'Infotrack@Modelos/smartStock/pisos/entidades/pisos';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import PisosCM from '../controladorModelo/pisosCM';
import { IFormularioPisosCVProps } from '../interfaces';
import { acciones, IEstadoPisos } from '../reductorPisos';
import FormularioPisosVista from '../vista/formularioPisosVista';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { useSelector } from 'react-redux';

const estadoInicial: IPisos = {
    EmpresaId: '',
    DescripcionPiso: '',
    Estado: 1,
    AgenciaId: '',
};
const pisosCM = new PisosCM();

const FormularioPisosCV: React.FunctionComponent<IFormularioPisosCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadPisos }, dispatch] = useProveedor<IEstadoPisos>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IPisos>(estadoInicial);

    React.useEffect(() => {
        if (entidadPisos && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadPisos);
        } else {
            reiniciar();
        }
    }, [entidadPisos]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionPisos = () => {
        if (pisosCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarPisos,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarPisos = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            pisosCM
                .crearPisos({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            pisosCM
                .editarPisos({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioPisosVista
            accionCrearEditar={confirmarCreacionEdicionPisos}
            cambiarInfoFomulario={alCambiarValor}
            pisos={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioPisosCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioPisosCVProps, null, any, IEstadoGlobal>(estadoAPropiedades, null)(FormularioPisosCV);
